import React, { useEffect, useState } from "react";
import classes from "./payments.module.css";
import {
  FaWallet,
  FaStore,
  FaPhoneAlt,
  FaMoneyBillWave,
  FaGem,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransactions } from "../../../../redux/slices/bookingSlice";
import Transactions from "../../UserProfile/TransactionSection";

const Payments = () => {
  const [activeTab, setActiveTab] = useState("Summary");
  const dispatch = useDispatch();

  const { transactions } = useSelector((state) => state.booking);
  useEffect(() => {
    // Fetch transactions or any other data here if needed
    dispatch(fetchTransactions());
  }, []);

  return (
    <div className={classes.container}>
      <Transactions />
    </div>
  );
};

export default Payments;
